import { ANCHOR_PRODUCT } from "../constants";
import { getLocation } from "../../router/selectors";
import { updateLocationQuery } from "../../router/actions";
import { CAROUSEL_ID } from "../../../../components/FaceAndBodyCarousel/constants";

export const anchorProductToUrl = ({
  productTileId,
  pageNumber,
  carouselCatId
}) => (dispatch, getState) => {
  dispatch({ type: ANCHOR_PRODUCT });

  const { query } = getLocation(getState());

  dispatch(
    updateLocationQuery({
      query: {
        ...query,
        scrollTo: carouselCatId ? CAROUSEL_ID : productTileId,
        page: pageNumber > 1 ? pageNumber : undefined
      }
    })
  );
};
